export { default } from './Menu';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/Menu/index.js
// module id = 838
// module chunks = 2